import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import LoadingButtons from './LoadingButtons';
import ClientProvider from './client';
export default createDemo(import.meta.url, LoadingButtons, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/components/buttons/demos/loading/LoadingButtons.tsx",
    "fileName": "LoadingButtons.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import Button from '@mui/material/Button';\nimport SaveIcon from '@mui/icons-material/Save';\nimport Stack from '@mui/material/Stack';\n\nexport default function LoadingButtons() {\n  return (\n    <Stack spacing={2}>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus-unfocused",
            "dataFrameIndent": 3,
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "      <Stack direction=\"row\" spacing={2}>\n        <Button loading variant=\"outlined\">\n          Submit\n        </Button>\n        <Button loading loadingIndicator=\"Loading…\" variant=\"outlined\">\n          Fetch data\n        </Button>\n        <Button\n          loading\n          loadingPosition=\"start\"\n          startIcon={<SaveIcon />}\n          variant=\"outlined\"\n        >\n          Save\n        </Button>\n      </Stack>\n      <Button\n        fullWidth\n        loading\n        loadingPosition=\"start\"\n        startIcon={<SaveIcon />}\n        variant=\"outlined\"\n      >\n        Full width\n      </Button>\n      <Button\n        fullWidth\n        loading\n        loadingPosition=\"end\"\n        endIcon={<SaveIcon />}\n        variant=\"outlined\"\n      >\n        Full width\n      </Button>\n      <Stack direction=\"row\" spacing={2}>\n        <Button loading variant=\"outlined\" loadingPosition=\"start\">\n          Submit\n        </Button>\n        <Button loading variant=\"outlined\" loadingPosition=\"end\">\n          Submit\n        </Button>\n        <Button\n          loading\n          variant=\"outlined\"\n          loadingPosition=\"end\"\n          startIcon={<SaveIcon />}\n        >\n          Save\n        </Button>\n      </Stack>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    </Stack>\n  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 60,
        "focusedLines": 0,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import Button from '@mui/material/Button';\nimport SaveIcon from '@mui/icons-material/Save';\nimport Stack from '@mui/material/Stack';\n\nexport default function LoadingButtons() {\n  return (\n    <Stack spacing={2}>\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus-unfocused",
          "dataFrameIndent": 3
        },
        "      <Stack direction=\"row\" spacing={2}>\n        <Button loading variant=\"outlined\">\n          Submit\n        </Button>\n        <Button loading loadingIndicator=\"Loading…\" variant=\"outlined\">\n          Fetch data\n        </Button>\n        <Button\n          loading\n          loadingPosition=\"start\"\n          startIcon={<SaveIcon />}\n          variant=\"outlined\"\n        >\n          Save\n        </Button>\n      </Stack>\n      <Button\n        fullWidth\n        loading\n        loadingPosition=\"start\"\n        startIcon={<SaveIcon />}\n        variant=\"outlined\"\n      >\n        Full width\n      </Button>\n      <Button\n        fullWidth\n        loading\n        loadingPosition=\"end\"\n        endIcon={<SaveIcon />}\n        variant=\"outlined\"\n      >\n        Full width\n      </Button>\n      <Stack direction=\"row\" spacing={2}>\n        <Button loading variant=\"outlined\" loadingPosition=\"start\">\n          Submit\n        </Button>\n        <Button loading variant=\"outlined\" loadingPosition=\"end\">\n          Submit\n        </Button>\n        <Button\n          loading\n          variant=\"outlined\"\n          loadingPosition=\"end\"\n          startIcon={<SaveIcon />}\n        >\n          Save\n        </Button>\n      </Stack>\n"
      ],
      [
        "span",
        "frame",
        "    </Stack>\n  );\n}\n"
      ]
    ],
    "totalLines": 60,
    "focusedLines": 0,
    "collapsible": true,
    "externals": [
      "@mui/material/Button",
      "@mui/icons-material/Save",
      "@mui/material/Stack"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
